var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTokenAndBaseLayerRisk(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 272,
    height: 256,
    viewBox: "0 0 272 256",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M136 215.83C210.922 215.83 271.659 190.607 271.659 159.493C271.659 128.379 210.922 103.156 136 103.156C61.0777 103.156 0.341187 128.379 0.341187 159.493C0.341187 190.607 61.0777 215.83 136 215.83Z",
    fill: "url(#paint0_radial_337_7148)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M113.106 40.17V97.391L179.273 135.48L179.076 78.2594L113.106 40.17Z",
    fill: "url(#paint1_linear_337_7148)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M113.113 97.1643L113.083 143.006L126.344 150.653L126.351 120.089L152.789 135.367L152.804 165.923L166.058 173.668V127.705L113.113 97.1643Z",
    fill: "#8060EA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M179.258 120.081L166.057 127.705V173.668L179.273 165.923L179.258 120.081Z",
    fill: "#570EE5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M126.344 150.653L139.551 143.006L139.582 127.728L126.351 120.089L126.344 150.653Z",
    fill: "#570EE5"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M113.106 97.134L126.336 89.5101L179.265 120.066L166.02 127.72L113.106 97.134Z",
    fill: "url(#paint2_linear_337_7148)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M136.605 139.152L139.801 137.294L140.043 137.173L136.846 139.032L136.605 139.152Z",
    fill: "#390997"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M136.846 139.039L140.043 137.18C140.231 137.089 140.428 137.018 140.632 136.969L137.436 138.828C137.233 138.878 137.035 138.948 136.846 139.039Z",
    fill: "#3B0A9C"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M137.436 138.828L140.632 136.969C140.914 136.905 141.203 136.872 141.493 136.871L138.297 138.729C138.007 138.727 137.718 138.76 137.436 138.828Z",
    fill: "#3D0AA0"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M138.297 138.729L141.493 136.871C142.511 136.91 143.501 137.215 144.365 137.755L141.168 139.606C140.305 139.067 139.314 138.765 138.297 138.729Z",
    fill: "#3F0AA5"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M141.168 139.606L144.364 137.755L144.531 137.853L141.335 139.704L141.168 139.606Z",
    fill: "#3F0AA5"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M141.335 139.704L144.531 137.853C144.883 138.061 145.219 138.296 145.536 138.556L142.34 140.407C142.019 140.152 141.684 139.918 141.335 139.704Z",
    fill: "#3D0AA0"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M142.339 140.407L145.536 138.556C145.785 138.752 146.034 138.964 146.291 139.183L143.095 141.042C142.854 140.817 142.602 140.605 142.339 140.407Z",
    fill: "#3B0A9C"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M143.073 141.042L146.269 139.183C146.48 139.379 146.684 139.591 146.888 139.802L143.692 141.661C143.496 141.442 143.284 141.238 143.073 141.042Z",
    fill: "#390997"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M143.692 141.661L146.888 139.802C147.077 140.006 147.266 140.218 147.44 140.437L144.244 142.288C144.07 142.077 143.881 141.865 143.692 141.661Z",
    fill: "#380993"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M144.244 142.288L147.44 140.437C147.621 140.649 147.795 140.868 147.961 141.094L144.765 142.93C144.599 142.704 144.425 142.485 144.244 142.266",
    fill: "#36098E"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M144.765 142.931L147.961 141.072C148.127 141.306 148.294 141.54 148.445 141.782L145.249 143.686C145.097 143.452 144.931 143.21 144.765 142.983",
    fill: "#340889"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M145.249 143.686L148.445 141.835C148.611 142.084 148.77 142.349 148.921 142.591L145.725 144.442C145.573 144.177 145.415 143.92 145.249 143.686Z",
    fill: "#320885"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M145.725 144.442L148.921 142.583C149.094 142.885 149.253 143.18 149.397 143.49L146.17 145.333C146.027 145.031 145.868 144.729 145.694 144.434",
    fill: "#310880"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M146.17 145.333L149.367 143.482C149.548 143.852 149.714 144.238 149.865 144.608L146.669 146.459C146.518 146.081 146.352 145.703 146.17 145.333Z",
    fill: "#2F087C"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M146.699 146.459L149.895 144.608C150.44 145.946 150.732 147.373 150.757 148.817C150.757 150.842 150.039 152.262 148.883 152.935L145.687 154.786C146.843 154.121 147.553 152.7 147.561 150.675C147.535 149.229 147.243 147.8 146.699 146.459Z",
    fill: "#2D0777"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M145.686 154.794C148.186 153.341 148.18 148.665 145.673 144.349C143.165 140.034 139.106 137.714 136.605 139.167C134.105 140.62 134.111 145.296 136.618 149.611C139.126 153.926 143.185 156.247 145.686 154.794Z",
    fill: "#480CBE"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M92.75 51.8666V109.088L158.917 147.177L158.721 89.9559L92.75 51.8666Z",
    fill: "url(#paint3_linear_337_7148)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M92.7575 108.861L92.7273 154.703L105.995 162.349V131.786L132.434 147.064L132.449 177.62L145.702 185.365V139.402L92.7575 108.861Z",
    fill: "#8060EA"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M158.902 131.778L145.702 139.402V185.364L158.917 177.62L158.902 131.778Z",
    fill: "#570EE5"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M105.995 162.349L119.203 154.703L119.226 139.425L105.995 131.786V162.349Z",
    fill: "#570EE5"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M92.75 108.831L105.988 101.207L158.91 131.763L145.664 139.417L92.75 108.831Z",
    fill: "url(#paint4_linear_337_7148)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M116.257 150.857L119.453 148.998L119.687 148.877L116.491 150.736L116.257 150.857Z",
    fill: "#390997"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M116.491 150.736L119.687 148.877C119.876 148.787 120.073 148.717 120.276 148.665L117.08 150.524C116.877 150.575 116.68 150.646 116.491 150.736Z",
    fill: "#3B0A9C"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M117.08 150.524L120.276 148.665C120.559 148.601 120.848 148.568 121.138 148.567L117.942 150.426C117.652 150.423 117.362 150.456 117.08 150.524Z",
    fill: "#3D0AA0"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M117.942 150.426L121.138 148.567C122.156 148.605 123.146 148.91 124.009 149.451L120.813 151.302C119.949 150.763 118.959 150.46 117.942 150.426Z",
    fill: "#3F0AA5"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M120.813 151.302L124.009 149.451L124.175 149.549L120.987 151.401L120.813 151.302Z",
    fill: "#3F0AA5"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M120.986 151.401L124.175 149.549C124.529 149.759 124.867 149.994 125.188 150.252L121.991 152.103C121.669 151.852 121.333 151.618 120.986 151.401Z",
    fill: "#3D0AA0"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M121.991 152.103L125.188 150.252C125.437 150.449 125.679 150.66 125.943 150.879L122.747 152.753C122.505 152.527 122.263 152.315 121.991 152.119",
    fill: "#3B0A9C"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M122.747 152.753L125.936 150.895C126.147 151.091 126.359 151.303 126.555 151.514L123.367 153.373C123.163 153.154 122.959 152.95 122.747 152.753Z",
    fill: "#390997"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M123.344 153.358L126.533 151.499C126.721 151.703 126.91 151.914 127.092 152.134L123.896 153.985C123.714 153.773 123.533 153.562 123.344 153.358Z",
    fill: "#380993"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M123.896 153.985L127.092 152.134C127.265 152.345 127.439 152.564 127.605 152.791L124.409 154.65C124.243 154.423 124.069 154.204 123.896 153.985Z",
    fill: "#36098E"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M124.409 154.65L127.605 152.791C127.772 153.025 127.938 153.259 128.097 153.501L124.9 155.352C124.742 155.118 124.576 154.876 124.409 154.65Z",
    fill: "#340889"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M124.9 155.352L128.097 153.501C128.263 153.751 128.421 154.015 128.565 154.257L125.376 156.116C125.225 155.851 125.067 155.594 124.9 155.36",
    fill: "#320885"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M125.376 156.131L128.565 154.264C128.739 154.567 128.898 154.861 129.049 155.171L125.852 157.022C125.701 156.72 125.543 156.418 125.376 156.123",
    fill: "#310880"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M125.853 157.03L129.049 155.179C129.222 155.549 129.389 155.934 129.54 156.304L126.344 158.156C126.2 157.778 126.034 157.4 125.853 157.03Z",
    fill: "#2F087C"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M126.344 158.156L129.547 156.304C130.095 157.641 130.387 159.069 130.409 160.513C130.409 162.538 129.691 163.959 128.542 164.631L125.346 166.482C126.495 165.817 127.205 164.397 127.213 162.372C127.191 160.925 126.899 159.495 126.351 158.156",
    fill: "#2D0777"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M125.332 166.486C127.833 165.033 127.827 160.357 125.319 156.042C122.812 151.726 118.752 149.406 116.252 150.859C113.751 152.312 113.757 156.988 116.265 161.303C118.772 165.619 122.832 167.939 125.332 166.486Z",
    fill: "#480CBE"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_337_7148",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(136.235 159.505) scale(135.464 56.3163)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8060EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#8060EA",
    stopOpacity: 0.39
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#8060EA",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_337_7148",
    x1: 133.303,
    y1: 110.153,
    x2: 157.134,
    y2: 68.8674,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#88E2A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#88E2A1",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#88E2A1",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_337_7148",
    x1: 113.106,
    y1: 108.611,
    x2: 179.265,
    y2: 108.611,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#88E2A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#9FC0C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C08FFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_337_7148",
    x1: 112.947,
    y1: 121.849,
    x2: 136.778,
    y2: 80.5639,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#88E2A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#88E2A1",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#88E2A1",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_337_7148",
    x1: 92.75,
    y1: 120.308,
    x2: 158.91,
    y2: 120.308,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#88E2A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#9FC0C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C08FFF"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTokenAndBaseLayerRisk);
export default __webpack_public_path__ + "static/media/token_and_base_layer_risk.c2042efb168ba53db654653da79be030.svg";
export { ForwardRef as ReactComponent };